import { render, staticRenderFns } from "./PriceListProposalDetailView.vue?vue&type=template&id=59b67fa0"
import script from "./PriceListProposalDetailView.vue?vue&type=script&lang=js"
export * from "./PriceListProposalDetailView.vue?vue&type=script&lang=js"
import style0 from "./PriceListProposalDetailView.vue?vue&type=style&index=0&id=59b67fa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports